import React from "react";
import { Link } from "react-router-dom";
import ShadowzLogo from "../assets/images/ShadowzLogo.svg";

function VerifyEmail() {

  return (

    <div className="verify-email-wrapper">
      <div className="verify-email">
        <img
          src={ShadowzLogo}
          height={60}
          alt="ShadowzLogo"
          className="img-fluid logo mb-3 w-28"
        />
        <h2>Your email address has been verified</h2>
        <p>
          Thank you for your support, We have successfully verified your email
          address.{" "}
        </p>
        <p>You can now proceed to the homepage.</p>
        <Link to="/" className="btn btn-primary">
          Continue to Shadowz
        </Link>
      </div>
    </div>
  );
}
export default VerifyEmail;
